import { all } from 'redux-saga/effects';

import loginWatcher from './user/user';
import cruiseWatcher from './cruise/cruise';
import itineraryWatcher from './cruise/cruiseDetails';
import ratesWatcher from './cruise/rates';
import flightSearchWatcher from './flight/flight';
import autocompleteWatcher from './cruise/autocomplete';
import priceWatcher from './cruise/priceBreakdown';
import searchHotelsWatcher from './hotel/hotelSearch';
import hotelTripSearchWatcher from './hotel/hotelTripSearch';
import getHotelWatcher from './hotel/hotelDetails';
import availableCabinsWatcher from './cruise/cruiseAvailableCabins';
import tripSaveWatcher from './trip/tripSave';
import saveBrochureWatcher from './brochure/saveBrochure';
import sendBrochureWatcher from './brochure/sendBrochure';
import getBrochureWatcher from './brochure/getBrochure';
import tripUpdateWatcher from './trip/tripUpdate';
import getTripWatcher from './trip/getTrip';
import tripPriceCheckWatcher from './trip/tripPriceCheck';
import acceptTripPriceChangeWatcher from './trip/acceptTripPriceChange';
import getTripConfirmationWatcher from './trip/getTripConfirmation';
import tripBookWatcher from './trip/tripBook';
import saveSendTripEmailWatcher from './trip/saveSendTripEmail';
import availableCountriesWorker from './user/availableCountries';
import availableStatesWorker from './user/availableStates';
import getDiningOptionsWorker from './trip/getDiningOptions';
import getRateOptionRulesWatcher from './trip/getRateOptionRules';
import rentalCarsSearchWatcher from './car/rentalCars';
import getAgentTipsWatcher from './intelligence/getAgentTips';
import updateHotelInAgentTipWatcher from './intelligence/updateHotelInAgentTip';
import updateFlightInAgentTipWatcher from './intelligence/updateFlightInAgentTip';
import emailRequestWatcher from './trip/resendTripToEmail';
import getCarRateRulesWatcher from './car/getCarRateRules';
import getFlightSeatmapWatcher from './flight/getFlightSeatmap';
import getTravelAgencySettingsWatcher from './user/getTravelAgencySettings';
import getQuickLinksWatcher from './user/getQuickLinks';
import tripsSearchWatcher from './trip/tripsSearch';
import tripsCSVRequestWatcher from './trip/getTripsCsv';
import updateBrochurePriceWatcher from './brochure/updateBrochurePrice';
import getCallbackStatusWatcher from './callback/getCallbackStatus';
import sendCompareWatcher from './compare/sendCompare';
import getCompareWatcher from './compare/getCompare';
import cancelBookingWatcher from './trip/cancelBooking';
import getHotelRateCodesWatcher from './user/getHotelRateCodes';
import getFlightRateCodesWatcher from './user/getFlightRateCodes';
import getRentalCarDiscountCodesWatcher from './user/getRentalCarDiscountCodes';
import getHotelRoomDetailsWatcher from './hotel/getHotelRoomDetails';
import getRoomDescriptionWatcher from './hotel/getRoomDescription';
import sendCustomerQueryWatcher from './user/sendCustomerQuery';
import getPackagesWatcher from './trip/getPackages';
import getSpecialServicesWatcher from './trip/getSpecialServices';
import searchCustomersWatcher from './customer/searchCustomers';
import getSavedCardsWatcher from './customer/getSavedCards';
import deleteCardWatcher from './customer/deleteCard';
import setDefaultCardWatcher from './customer/setDefaultCard';
import deleteTripWatcher from './trip/deleteTrip';
import customInventorySearchWatcher from './inventory/customInventorySearch';
import tourSearchWatcher from './tour/tourSearch';
import getSabrePnrPrintoutWatcher from './trip/getSabrePnrPrintout';
import getCruiseBenefitsWatcher from './cruise/getCruiseBenefits';
import sendVerificationEmailWatcher from './user/sendVerificationEmail';
import verifyPagePasswordWatcher from './user/verifyPagePassword';
import getBasketContentWatcher from './trip/getBasketContent';
import getHotelKeyCodesWatcher from './hotel/getHotelRateCodeKeys';
import pollBookingStatusWatcher from './trip/pollBookingStatus';
import validateFlightSegmentsWatcher from './flight/validateFlightSegments';
import directSellFlightSearchWatcher from './flight/directSellFlight';
import checkAirAvailabilityWatcher from './flight/checkAirAvailability';
import insuranceWatcher from './insurance/insuranceSaga';
import getAirFareRulesWatcher from './flight/getAirFareRules';

export default function* rootSaga() {
  yield all([
    loginWatcher(),
    verifyPagePasswordWatcher(),
    cruiseWatcher(),
    itineraryWatcher(),
    ratesWatcher(),
    flightSearchWatcher(),
    priceWatcher(),
    autocompleteWatcher(),
    searchHotelsWatcher(),
    hotelTripSearchWatcher(),
    getHotelWatcher(),
    availableCabinsWatcher(),
    tripSaveWatcher(),
    tripUpdateWatcher(),
    getTripWatcher(),
    tripPriceCheckWatcher(),
    acceptTripPriceChangeWatcher(),
    getTripConfirmationWatcher(),
    tripBookWatcher(),
    availableCountriesWorker(),
    availableStatesWorker(),
    saveSendTripEmailWatcher(),
    getDiningOptionsWorker(),
    getRateOptionRulesWatcher(),
    rentalCarsSearchWatcher(),
    getAgentTipsWatcher(),
    updateHotelInAgentTipWatcher(),
    updateFlightInAgentTipWatcher(),
    emailRequestWatcher(),
    getCarRateRulesWatcher(),
    saveBrochureWatcher(),
    sendBrochureWatcher(),
    getBrochureWatcher(),
    getFlightSeatmapWatcher(),
    getTravelAgencySettingsWatcher(),
    getQuickLinksWatcher(),
    tripsSearchWatcher(),
    tripsCSVRequestWatcher(),
    updateBrochurePriceWatcher(),
    getCallbackStatusWatcher(),
    sendCompareWatcher(),
    getCompareWatcher(),
    cancelBookingWatcher(),
    getHotelRateCodesWatcher(),
    getFlightRateCodesWatcher(),
    getRentalCarDiscountCodesWatcher(),
    getHotelRoomDetailsWatcher(),
    getRoomDescriptionWatcher(),
    sendCustomerQueryWatcher(),
    getPackagesWatcher(),
    getSpecialServicesWatcher(),
    searchCustomersWatcher(),
    getSavedCardsWatcher(),
    deleteTripWatcher(),
    deleteCardWatcher(),
    setDefaultCardWatcher(),
    customInventorySearchWatcher(),
    tourSearchWatcher(),
    getSabrePnrPrintoutWatcher(),
    getCruiseBenefitsWatcher(),
    sendVerificationEmailWatcher(),
    getBasketContentWatcher(),
    getHotelKeyCodesWatcher(),
    pollBookingStatusWatcher(),
    validateFlightSegmentsWatcher(),
    directSellFlightSearchWatcher(),
    checkAirAvailabilityWatcher(),
    insuranceWatcher(),
    getAirFareRulesWatcher(),
  ]);
}
